<template>
  <div>
    <ul class="news_list">
        <li v-for="item in dataList" :key="item.id">
            <span class="date" v-if="dateIsShow">{{item.date}}</span>
            <a @click.prevent="confirmClick(item.linkUrl)" v-if="item.linkUrl" :href="item.linkUrl" :style="aWidth" target="_blank">{{item.title}}</a>
            <router-link v-else :to="'/detail/'+item.id" :style="aWidth" target="_blank">{{item.title}}</router-link>
        </li>
    </ul>
    <div class="dialog_other_link" v-show="confirm">
      <div @click="close" class="close">X</div>
      <div class="content">
        <p>您访问的链接即将离开“海淀区人民政府”门户网站</p>
        <p>是否继续？</p>
      </div>
      <div class="btn_box">
        <span @click="goLink" class="btn_jxfw">继续访问</span>
        <span @click="close" class="btn_fq">放弃</span>
      </div>
    </div>
    <div class="dialog_mask" v-show="confirm"></div>
  </div>
</template>

<script>
export default {
  props: ['dataList', 'aWidth', 'dateIsShow'],
  data() {
    return {
      confirm: false,
      linkUrl: '',
    }
  },
  methods: {
    // 跳转外链前打开确认弹窗
    confirmClick(url) {
      this.confirm = true
      this.linkUrl = url
    },
    // 关闭弹窗
    close() {
      this.confirm = false
      this.linkUrl = ''
    },
    // 继续访问
    goLink() {
      window.open(this.linkUrl)
      this.close()
    }
  },
}
</script>
<style lang="less" scoped>
  .dialog_mask {
    // width: 100vw;
    // height: 100vh;
    background: #000;
    opacity: .5;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99;
  }
  .dialog_other_link {
    height: 270px;
    background: #FFF;
    padding: 0 60px;
    overflow: hidden;
    position: fixed;
    left: 50%;
    top: 100px;
    margin: 0 0 0 -300px;
    z-index: 999;

    .close {
      width: 20px;
      height: 20px;
      background-color: #ababab;
      color: #FFF;
      line-height: 20px;
      text-align: center;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 9;
      cursor: pointer;
    }

    .content {
      margin: 50px auto 0;
      font-size: 20px;
      text-align: center;
      padding-bottom: 30px;
      border-bottom: solid 1px #EDEDED;
      width: auto;
      height: auto;
      position: relative;
    }

    .btn_box {
      text-align: center;
      margin-top: 30px;
    }

    .btn_jxfw {
      display: inline-block;
      vertical-align: top;
      width: 120px;
      height: 40px;
      border: solid 1px #EEE;
      border-radius: 10px;
      font-size: 20px;
      color: #aa0000;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
    .btn_fq {
      font-size: 20px;
      color: #aa0000;
      margin-left: 20px;
      line-height: 40px;
      cursor: pointer;
    }
  }
</style>